<template>
  <div>
    <div class="form flex a-center j-between mt--23">
      <div class="form-left ml--30">
        <el-form :inline="true">
          <el-form-item label="人员搜索" style="margin-right: 100px;">
            <el-input v-model="nickNameOrPhone" placeholder="请输入姓名/联系电话"></el-input>
          </el-form-item>
          <el-form-item label="人员角色" style="margin-right: 100px;">
            <el-select v-model="roleId" placeholder="请选择（多选）" multiple>
              <el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName" :value="item.roleId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账号状态" style="margin-right: 100px;">
            <el-select v-model="status" placeholder="请选择">
              <el-option
                v-for="item in [{ label: '全部', value: '' }, { label: '启用', value: 0 }, { label: '禁用', value: 1 }]"
                :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="form-right mr--24 mb--22 shrink0">
        <el-button class="search-button h--40 w--90 fs--14" icon="el-icon-search" type="primary" size="small"
          @click="onSubmit">查询</el-button>
        <el-button @click="reset" icon="el-icon-refresh-right" class="reset-button h--40 w--90 fs--14"
          size="small">重置</el-button>
      </div>
    </div>
    <div class="table-box-btn mt--23 ml--30">
      <el-button v-permission="17" class="search-button h--40 w--90 fs--14" icon="el-icon-plus" type="primary" size="small"
        @click="dialogVisible = true">添加</el-button>
      <!-- <el-button class="search-button h--40 w--90 fs--14" icon="el-icon-delete" type="danger" size="small"
        @click="dialogVisible = true">删除</el-button> -->
    </div>
    <div class="table-box ml--30 mt--23 mr--30">
      <el-table :data="data" border stripe style="width: 100%" :element-loading-text="'正在加载...'">
        <el-table-column prop="nickName" label="姓名"></el-table-column>
        <el-table-column prop="phonenumber" label="联系电话">
        </el-table-column>
        <el-table-column prop="roleName" label="角色">
          <template #default="{ row }">
            {{ row.roleNames[0] }}
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="登陆账号">
        </el-table-column>
        <el-table-column prop="remark" label="备注">
        </el-table-column>
        <el-table-column prop="status" label="账号状态">
          <template #default="{ row }">
            <div class="status_class">
              <div :class="row.status == 0 ? 'green' : 'red'"></div>
              <div>{{ row.status == 0 ? '正常' : '停用' }}</div>
              <div v-if="row.status == 1" style="cursor: pointer;">
                <el-tooltip class="item" effect="dark" :content="`禁用原因：${row.forbiddenRemark}`" placement="top-start">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="300">
          <template #default="{ row }">
            <div v-if="row.userId != 1">
              <el-button v-permission="19" type="text" @click="edit(row)">编辑</el-button>
              <el-button v-permission="20" v-if="row.status != 0" type="text" @click="updateStatus(row, true)">启用</el-button>
              <el-button v-permission="20" v-if="row.status == 0" type="text" @click="updateStatus(row, false)">禁用</el-button>
              <el-button v-permission="21" type="text" @click="detail(row)">重置密码</el-button>
              <el-button v-permission="18" type="text" @click="del(row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="relative mt--23 flex j-end">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="searchForm.pageNum" background layout="total,sizes,prev, pager, next,jumper"
          :total="searchForm.total">
        </el-pagination>
      </div>
    </div>

    <AddEdit v-if="dialogVisible" :row="row" :roleList="roleList" :dialogVisible="dialogVisible"
      @close="dialogVisible = false, row = {}" @confirm="confirm" />
    <ResetPassword v-if="passwordVisible" :row="row" :dialogVisible="passwordVisible"
      @close="passwordVisible = false, row = {}" @confirm="passwordConfirm" />
    <Disb v-if="disbDialogVisible" :row="disbRow" :dialogVisible="disbDialogVisible"
      @close="disbDialogVisible = false, disbRow = {}" @confirm="disbConfirm" />
    <ShowDelConfirm :show="delShow" @close="delShow = false" @confirm="delConfirm" title="确认要删除该人员吗？"
      tip="删除人员后，该人员不可登录。如非必要，系统建议您使用禁用功能。" okText="确定删除" />
  </div>
</template>

<script>
import { getList, add, edit, delDept, roleList, updatePwd, changeStatus } from './service'
import AddEdit from './components/addEdit.vue'
import Disb from './components/disb.vue'
import ResetPassword from './components/resetPassWord.vue'
import ShowDelConfirm from '@/components/ShowDelConfirm'
export default {
  components: {
    AddEdit,
    Disb,
    ResetPassword,
    ShowDelConfirm,
  },
  data() {
    return {
      dialogVisible: false,
      passwordVisible: false,
      disbDialogVisible: false,
      delShow: false,
      data: [],
      nickNameOrPhone: '',
      deptId: [],
      roleId: [],
      status: '',
      roleList: [],
      searchForm: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      row: {},
      rowView: {},
      disbRow: {},
      delId: '',
    };
  },
  computed: {
    height() {
      return this.$baseTableHeight()
    },
  },
  watch: {},
  created() {
    this.$checkPermission(16)

    this.getRoleList()
    this.getListData()
  },
  mounted() { },
  methods: {
    getRoleList() {
      roleList().then((res) => {
        this.roleList = res.records
      })
    },
    delConfirm() {
      delDept(this.delId).then(() => {
        this.delShow = false
        this.disbRow = {}
        this.msgsuccess('删除成功')
        this.getListData()
      })
    },
    disbConfirm(form) {
      changeStatus({
        remark: form.disableRemark,
        userId: form.userId
      }).then(res => {
        this.disbDialogVisible = false
        this.msgsuccess('禁用成功')
        this.getListData()
      })
    },
    confirm(form) {
      if (form.userId) {
        edit(form).then(() => {
          this.row = {}
          this.dialogVisible = false
          this.msgsuccess('修改成功')
          this.getListData()
        })
      } else {
        add(form).then(() => {
          this.row = {}
          this.dialogVisible = false
          this.msgsuccess('添加成功')
          this.getListData()
        })
      }
    },
    passwordConfirm(form) {
      updatePwd(form).then(() => {
        this.row = {}
        this.passwordVisible = false
        this.msgsuccess('修改密码成功')
        this.getListData()
      })
    },
    detail(row) {
      this.passwordVisible = true
      this.row = row
    },
    edit(row) {
      this.row = row
      this.dialogVisible = true
    },
    updateStatus(row, type) {
      if (type == true) {
        changeStatus({
          userId: row.userId
        }).then(res => {
          this.disbDialogVisible = false
          this.msgsuccess('启用成功')
          this.getListData()
        })
      } else {
        this.disbRow = row
        this.disbDialogVisible = true
      }
    },
    del(row) {
      this.delShow = true
      this.delId = row.userId
    },
    getListData() {
      let obj = {
        ...this.searchForm,
        nickNameOrPhone: this.nickNameOrPhone,
        roleIds: this.roleId,
        status: this.status,
      }
      getList(obj).then((res) => {
        this.searchForm.total = res.total
        this.data = res.records
      })
    },
    reset() {
      this.nickNameOrPhone = ''
      this.roleId = []
      this.deptId = []
      this.status = ''
      this.searchForm.pageNum = 1
      this.getListData()
    },
    onSubmit() {
      this.searchForm.pageNum = 1
      this.getListData()
    },

    handleCurrentChange(e) {
      this.searchForm.pageNum = e;
      this.getListData()
    },
    handleSizeChange(e) {
      this.searchForm.pageSize = e
      this.getListData()
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-form-item .el-input__inner {
  width: 240px;
  height: unset !important;
}

.green {
  background-color: green;
}

.red {
  background-color: red;
}

.status_class {
  display: flex;
  align-items: center;

  div:nth-child(1) {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    margin-right: 5px;
  }

  div:nth-child(2) {
    margin-right: 8px;
  }
}
</style>